import {Types} from "../../../type/Types";

export type ShoppingPathValueObject = {
    id: bigint
    isActive: boolean
    name: string | null
    format: string
    visibility: string
    type: number
    weight: bigint
    minValue: bigint | null
    maxValue: bigint | null
    minLocalDate: Date | null
    maxLocalDate: Date | null
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
    wishState: boolean
}

export namespace ShoppingPathValueObject {
    export function construct(o: any): ShoppingPathValueObject {
        return {
            id: BigInt(o.id),
            isActive: Boolean(o.isActive),
            name: Types.asNull(o.name,String),
            format: String(o.format),
            visibility: String(o.visibility),
            type: Number(o.type),
            weight: BigInt(o.weight),
            minValue: Types.asNull(o.minValue,BigInt),
            maxValue: Types.asNull(o.maxValue,BigInt),
            minLocalDate: Types.asNull(o.minLocalDate, o => new Date(o)),
            maxLocalDate: Types.asNull(o.maxLocalDate, o => new Date(o)),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
            wishState: Boolean(o.wishState),
        }
    }

    export const description: Record<keyof ShoppingPathValueObject, string> = {
        id: 'ID',
        isActive: '활성상태',
        name: '이름',
        format: '미션경로',
        visibility: '보임여부',
        type: '유형',
        weight: '가중치',
        minValue: '사용자 참여 카운트 범위 최솟값',
        maxValue: '사용자 참여 카운트 범위 최댓값',
        minLocalDate: '특정 기간 최소 일자',
        maxLocalDate: '특정 기간 최대 일자',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
        wishState: '활성상태(입력)'
    }
}